import { ReactElement } from 'react';

import { IconFillColor, IconWrapper, StyledMargin } from '@dreryk/react-components';

type AppointmentEncounterModeIconProps = Readonly<{ icon: ReactElement }>;

export const AppointmentEncounterModeIcon = (props: AppointmentEncounterModeIconProps): JSX.Element => {
   return (
      <StyledMargin right={4}>
         <IconWrapper testId={'encounterModeIcon'} fillColor={IconFillColor.BACKGROUND}>
            {props.icon}
         </IconWrapper>
      </StyledMargin>
   );
};
